import React from 'react';
import { Accordion, Card, Row, Col, Button, Alert, Toast } from 'react-bootstrap';
import EventAddDetail from './EventAddDetail';
import EventAddLocation from './EventAddLocation';
import DateChooseList from "../dateChoice/DateChooseList";
//import InvitedList from '../invited/InvitedList';
import Sharing from "../util/Sharing"
import EventUserInfo from './EventUserInfo';
import { translate } from "react-i18next";
import './EventAddTabs.css';
import { sendJson, EDIT_URL, TEMPORARY, CREATED , fileUpload} from '../../backend/Backend';
import { Redirect } from 'react-router-dom';
import { GREEN_LIGHT, WARNING } from '../../backend/Colors';
import '../../components/Home.css';
import i18n from "i18next";

function emptyEventDetail() {
  return {eventType:'PRIVATE',  title: '', description: '', commentsEnabled: '', location: '', limitParticipants: '', maxParticipants: '', limitDateChoose: '', eventStatus: '', eventLink: '', lang:'' };
}

function emptyLocationDetail() {
  return { locationName: '', street: '', zipcode: '', city: '', country: 'CH' };
}

function emptyUserInfo() {
  return { username: '', email: '', id: '' };
}

class EventAddPages extends React.Component {
  constructor(props) {
    super(props);
    this.saveEvent = this.saveEvent.bind(this);
    this.updateModel = this.updateModel.bind(this);
    this.goTo = this.goTo.bind(this);
    this.fileChanged = this.fileChanged.bind(this);
    this.removeFile = this.removeFile.bind(this);

    this.state = {
      event: {
        eventDetail: emptyEventDetail(), locationDetail: emptyLocationDetail(), eventAddUser: emptyUserInfo(),
        eventDates: [], inviteds: [], wishs: []
      },
      file: null,
      key: "0",
      pageKeys: [],
      message: '',
      redirect: false,
      redirectLink: '',
      inviteLink: ''
    }
  }

  updateModel(name, value, action) {
    let oldState = this.state;
    let oldEvent = this.state.event;
    if (name === "eventDates") {
      if (action === 'EVENTDATE_ADD') {
        oldEvent.eventDates = [].concat(oldEvent.eventDates, [value]);
      }
      if (action === 'EVENTDATE_REMOVE') {
        oldEvent.eventDates = oldEvent.eventDates.filter(eventDate => eventDate.startDate !== value.startDate);
      }

    } else if (name === "eventDetail") {
      //oldEvent.eventDetail = value;

      oldEvent.eventDetail.title = value.title;
      oldEvent.eventDetail.description = value.description;
      oldEvent.eventDetail.eventLink = value.eventLink;
      oldEvent.eventDetail.commentsEnabled = value.commentsEnabled;
      oldEvent.eventDetail.maxParticipants = value.maxParticipants;
      oldEvent.eventDetail.eventCategory = value.eventCategory;
      oldEvent.eventDetail.subCategory = value.subCategory;
      oldEvent.eventDetail.eventType = value.eventType;
 
    } else if (name === "eventLocation") {
      oldEvent.eventDetail.locationName = value.locationName;
      oldEvent.eventDetail.street = value.street;
      oldEvent.eventDetail.zipcode = value.zipcode;
      oldEvent.eventDetail.city = value.city;
      oldEvent.eventDetail.country = value.country;
    } else if (name === "inviteds") {
      console.log("updateModel add user " + name + " " + value + " " + action);
      if (action === 'INVITED_ADD') {
        oldEvent.inviteds = [].concat(oldEvent.inviteds, [value]);
      }
      if (action === 'INVITED_REMOVE') {
        oldEvent.inviteds = oldEvent.inviteds.filter(invited => (invited.email !== value.email) || (invited.username !== value.username));
      }
      console.log("updateModel add user " + JSON.stringify(oldEvent.inviteds));
    } else if (name === "eventAddUser") {
      oldEvent.eventAddUser.username = value.username ;
      oldEvent.eventAddUser.email = value.email ;
      oldEvent.eventAddUser.id = value.id
      
    }
    this.setState({
      ...oldState,
      event: oldEvent
    });
  }

  async componentDidMount() {
    let userValidate = this.state.event.eventAddUser.id > 0 || this.state.event.eventAddUser.email !== '' || this.state.event.eventAddUser.id > 0;
    if (userValidate && this.state.event.eventAddUser.id > 0) {
      this.onSelectTab("1");
    }
  }

  fileChanged(file) {
    let oldEvent = this.state.event; 
    oldEvent.eventDetail.file = file;
    let oldState = this.state;
    this.setState({
      ...oldState,
      file: file,
      event: oldEvent
    });
  }

  removeFile() {
    let oldState = this.state;
    this.setState({
      ...oldState,
      file: null
    });
  }



  saveEvent(status) {
    const { event } = this.state;
    event.eventDetail.eventStatus = status;
    event.eventDetail.lang = i18n.language;
    console.log("saving event2 : " + JSON.stringify(event));
    

    sendJson('post', 'events/createEvent', event).then(
      received => {
        if (received.ok) {
          let oldState = this.state;
          this.setState({
            ...oldState,
            message: received.message,
            redirectLink: received.data.creatorLink,
            inviteLink: received.data.inviteLink
          });

          //setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
          console.log("upload  image : " + received.id);
        if (received.ok && received.id) {
          this.executeFileUpload(this.state.file, received.id)
        }
        }
      });

  }

  executeFileUpload(file, id) {
    if(!file){
      return;
    }

  
     fileUpload(file, id, 1);
     let oldState = this.state;
     this.setState({
       ...oldState,
       message: 'fileUploaded'
     });
     setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
  }

  goTo(link) {
    let oldState = this.state;
    this.setState({
      ...oldState,
      event: {
        eventDetail: emptyEventDetail(), locationDetail: emptyLocationDetail(), eventAddUser: emptyUserInfo(),
        eventDates: [], inviteds: [], wishs: []
      },
      redirect: true,
      redirectLink: link
    })
  }




  onSelectTab(name) {
    let oldState = this.state;
    let oldPageKeys = this.state.pageKeys;
    oldPageKeys = [].concat(oldPageKeys, [name]);
    this.setState({ ...oldState, key: name, pageKeys: oldPageKeys });
  }


  isTemporarily() {
    return this.state.event.eventDetail.eventStatus === TEMPORARY
  }

  resolveBg(key) {
    return this.state.key === key ? "bg-success" : "bg-white";
  }

  resolveClassName(key) {
    return this.state.key === key ? "bg-light" : "bg-white";
  }

  resolveEventType() {
    if(this.state.event.eventDetail.title){
      return this.state.event.eventDetail.eventType === 'PRIVATE' ?  " fas fa-lock " : " fas fa-globe-europe ";
    }
    return " fa fa-question ";
  }




  resolveColor(key) {
    return this.state.key === key ? "GREEN" : "#343a40";
  }

  resolveIconColor(key) {
    return "GREEN";
  }
  render() {

    if (this.state.redirectLink && !this.isTemporarily() ) {
      return <Redirect to={'eventEdit/'+this.state.redirectLink} />
    }
    //d-relative 
    const { t } = this.props;
    let validateDetail = this.state.event.eventDetail.title !== '' || this.state.event.eventDetail.description !== '' || this.state.event.eventDetail.location !== '';
    let validateEventDates = this.state.event.eventDates && this.state.event.eventDates.length > 0
    let userValidate = this.state.event.eventAddUser.id > 0 || (this.state.event.eventAddUser.email !== '' && this.state.event.eventAddUser.username !== '') || this.state.event.eventAddUser.id > 0;
    let userFullname = userValidate ? this.state.event.eventAddUser.username ? this.state.event.eventAddUser.username : this.state.event.eventAddUser.email : '';
    console.log("locationName*** :"+JSON.stringify(this.state.event.eventDetail));
    // className=" cMaxWidth justify-content-xl-center d-relative " 
    return (
      <div className=" mt-5 ml-2" >
        <Row className="justify-content-md-center  mb-3" >
            <Col lg={8} md={12}>
               <h3 className="text-success">{t("createNewActivity")}</h3>
            </Col>
            </Row>
        <Row className="justify-content-md-center">
          <Col lg={8} md={12}  >
            <Accordion defaultActiveKey="0" activeKey={this.state.key}>
              <Card>
                <Card.Header className={this.resolveClassName('0')} >
                  <Accordion.Toggle as={Button} variant="link" eventKey="0" onClick={() => this.onSelectTab('0')}>
                    <i style={{ "color": this.resolveIconColor('0') }} className={" fa fa-user s24 mr-3 ml-0 w24"} ></i>
                    <span className="addTitle" style={{ "color": this.resolveColor('0') }}>{userFullname ? userFullname : t("wer")}</span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body style={{ "background": GREEN_LIGHT }} >
                    <EventUserInfo updateModel={this.updateModel.bind(this)} />
                    {!this.state.pageKeys.includes('1') ?
                      <Button variant="primary mt-5 mb-2" onClick={() => this.onSelectTab('1')} className="float-right mt-5 mr-1" disabled={userValidate !== true} variant="success">{t("Weiter")}</Button>
                      :
                      ''
                    }

                  </Card.Body>
                </Accordion.Collapse> 
              </Card>

              {(userValidate === true && (this.state.key === '1' || this.state.pageKeys.indexOf('1') >= 0)) ? (
                <Card>
                  <Card.Header className={this.resolveClassName('1')}  >
                    <Accordion.Toggle as={Button} variant="link" eventKey="1" onClick={() => this.onSelectTab('1')}>
                      <i style={{ "color": this.resolveIconColor('1') }} className={this.resolveEventType()+ " s24 mr-3 w24"} ></i>
                      <span className="addTitle" style={{ "color": this.resolveColor('1') }}>{this.state.event.eventDetail.title ? 
                      this.state.event.eventDetail.title : t("WasMoechtestDuPlanen")}</span>
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="1"  >
                    <Card.Body style={{ "background": GREEN_LIGHT }}>
                      <EventAddDetail updateModel={this.updateModel.bind(this)} detailModel={this.state.event.eventDetail} fileChanged={this.fileChanged.bind(this)}
                        removeFile = {this.removeFile.bind(this)} />
                      {!this.state.pageKeys.includes('2') ?
                        <Button variant="primary mt-5 mb-2" onClick={() => this.onSelectTab('2')} className="float-right mt-5 mr-1" disabled={validateDetail !== true} variant="success">{t("Weiter")}</Button>
                        :
                        ''
                      }
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ) : (<div></div>)}
              {(userValidate === true && (this.state.key === '2' || this.state.pageKeys.indexOf('2') >= 0)) ? (
               
                <Card>
                  <Card.Header className={this.resolveClassName('2')}  >
                    <Accordion.Toggle as={Button} variant="link" eventKey="2" onClick={() => this.onSelectTab('2')}>
                      <i style={{ "color": this.resolveIconColor('2') }} className={" fas fa-map-marker s24 mr-3 w24"} ></i>
                      <span className="addTitle" style={{ "color": this.resolveColor('2') }}>{this.state.event.eventDetail.locationName ? this.state.event.eventDetail.locationName  : t("Wo")}</span>
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="2"  >
                    <Card.Body style={{ "background": GREEN_LIGHT }}>
                      <EventAddLocation updateModel={this.updateModel.bind(this)} detailModel={this.state.event.locationDetail} />
                      {!this.state.pageKeys.includes('3') ?
                        <Button variant="primary mt-5 mb-2" onClick={() => this.onSelectTab('3')} className="float-right mt-5 mr-1" disabled={validateDetail !== true} variant="success">{t("Weiter")}</Button>
                        :
                        ''
                      }
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ) : (<div></div>)}
              {(validateDetail === true && (this.state.key === '3' || this.state.pageKeys.indexOf('3') >= 0)) ? (
                <Card>
                  <Card.Header className={this.resolveClassName('3')}>
                    <Accordion.Toggle as={Button} variant="link" eventKey="3" onClick={() => this.onSelectTab('3')}>
                      <i style={{ "color": this.resolveIconColor('3') }} className=" fa fa-clock s24 mr-3 w24" ></i>
                      <span className="addTitle" style={{ "color": this.resolveColor('3') }}>{t("Terminsvorschlaege")}</span>
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body style={{ "background": GREEN_LIGHT }}>
                      <DateChooseList updateModel={this.updateModel.bind(this)} redirectLink={this.state.redirectLink !== ''} />

                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ) : (<div></div>)}

            </Accordion>
          </Col>
        </Row>

        {this.state.message ?
          <Row className="mt-2">
            <Col>
              <Alert variant="success">
                <Row>
                  <Col>{t(this.isTemporarily() ? "tempEventCreated" : "eventCreated")}</Col>
                </Row>
                {this.isTemporarily() ?
                  '' :
                  <div>
                    <Row>
                      <Col> <Sharing url={EDIT_URL + this.state.inviteLink} title={t("eventPartLink")} /></Col>
                    </Row>
                    <Row className="mt-3">

                      <Col><Button onClick={() => this.goTo("/eventEdit/" + this.state.redirectLink)} className=" float-left" variant="success">
                        {" " + t("yourEventLink")}
                      </Button></Col>
                    </Row>
                  </div>

                }

              </Alert>

            </Col>
          </Row>

          :
          ""
        }

{this.state.key === '0' && !userValidate ?
          <Row className="justify-content-md-center mt-3 mb-2" >
            <Col lg={8} md={12}>
              <Toast style={{"backgroundColor":WARNING}}>
                <Toast.Body>{t("requiredUsername")}</Toast.Body>
              </Toast>
            </Col>
          </Row>
          : 
         ''
        }
         {this.state.key === '1' && !validateDetail ?
          <Row className="justify-content-md-center mt-3  mb-2">
            <Col lg={8} md={12}>
              <Toast  style={{"backgroundColor":WARNING}}>
                <Toast.Body>{t("requiredDetail")}</Toast.Body>
              </Toast>
            </Col>
          </Row>
          : ''
        }
         {this.state.key === '3' && !validateEventDates ?
          <Row className="justify-content-md-center mt-3 mb-2" >
            <Col lg={8} md={12}>
              <Toast style={{"backgroundColor":WARNING}}>
                <Toast.Body>{t("requiredTermin")}</Toast.Body>
              </Toast>
            </Col>
          </Row>
          : ''
        }

        {(!this.state.redirectLink && validateDetail === true && (this.state.key === '2' || this.state.pageKeys.indexOf('2') >= 0)
          && this.state.event.eventAddUser.username !== '' && this.state.event.eventAddUser.email !== ''
        ) ? (
            <Row className="justify-content-md-center">
              <Col className={'float-right mr-3 '} lg={8} md={12}>
                <Button variant="outline-success" onClick={() => this.saveEvent(CREATED)} className={'float-right mt-3 text-dark '} disabled={validateDetail !== true || validateEventDates !== true} >
                  <span  >{t("finish")}</span></Button>
                  { this.state.event.eventAddUser.id ?
                <Button variant="outline-success" onClick={() => this.saveEvent(TEMPORARY)} className={'float-right  mt-3 mr-1 mr-1  text-dark'} disabled={validateDetail !== true} >
                <span >{t("temporarySave")}</span></Button>
                :''
                  }

                <Button variant="outline-success" onClick={() => this.goTo("/")} className={'float-right mt-3 mr-1 text-dark'} disabled={validateDetail !== true} >
                  <span  >{t("cancel")}</span></Button>

              </Col>
            </Row>
          ) : (<Row className="justify-content-md-center">
            <Col className={'float-right mr-3 '} lg={8} md={12}>
              <Button variant="outline-success" onClick={() => this.goTo("/")} className={'float-left mt-3 mr-1 text-dark'} >
                <span  >{t("cancel")}</span></Button>

            </Col>
          </Row>)}
        
      </div>);
  }
}

export default translate("translations")(EventAddPages);
